import { useTranslation } from "react-i18next";
import useIdentity from "@/features/ui/hooks/use-identity";
import { Helmet } from "react-helmet-async";
import BuyerInventoryListPage from "@/features/inventories/buyer-inventory-list-page";
import AgencyInventoryListPage from "@/features/inventories/agency-inventory-list-page";
import { getCanonicalUrl } from "@/shared/utils/canonical-url";

export default function InventoryListPage() {
  const identity = useIdentity();
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>Pathrade | {t("inventories")}</title>
        <link
          rel="canonical"
          href={getCanonicalUrl()}
        />
        <meta property="og:title" content={`Pathrade | ${t("inventories")}`} />
        <meta
          property="og:url"
          content={getCanonicalUrl()}
        />
      </Helmet>
      {identity?.company?.type === "AGENCY" ? (
        <AgencyInventoryListPage />
      ) : identity?.company?.type === "BUYER" ? (
        <BuyerInventoryListPage />
      ) : (
        <></>
      )}
    </>
  );
}
